import { calculateFileSize, timestampToDate } from "@/helpers";

const documentLocalizer = payload => ({
    fileName : payload.name,
    baseName: payload.basename,
    files: {
        path: payload.path,
        fileName : payload.name,
        children : payload.children,
        webViewLink: payload?.webViewLink,
        baseName: payload.basename,
        type: payload.type,
        mimeType: payload?.mimetype,
        lastModified: timestampToDate(payload.timestamp),
        fileSize: calculateFileSize(payload?.size)
    },
    type: payload.type,
    mimeType: payload?.mimetype,
    lastModified: timestampToDate(payload.timestamp),
    fileSize: calculateFileSize(payload?.size)
});

export default documentLocalizer;